import {uploadOrderExcel} from 'api/orderExcel';
import Cookies from 'js-cookie';

const orderExcel = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        uploadOrderExcel({commit},params) {
            return new Promise((resolve, reject) => {
                uploadOrderExcel(params.attachments, params.type).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default orderExcel;



// WEBPACK FOOTER //
// ./src/store/modules/orderExcel.js